import React from "react";
import { Link } from 'react-router-dom';

import warningIcon from "common-ui-components/components/icons/warning.svg";
import downloadIcon from "common-ui-components/components/icons/download.svg";
import BasicMessage from "message-framework/components/BasicMessage";
import styles from "./AgentDownloadAlert.module.css";

export const AgentDownloadAlert = () => (
  <BasicMessage
    icon={warningIcon}
    title="Agent Not Installed"
    component={
      <div className={styles.agentDownloadAlert}>
        <div className={styles.agentDownloadIconWrap}>
          <img
            src={warningIcon}
            alt=""
            className={styles.agentDownloadWarningIcon}
          />
        </div>
        <div className={styles.agentDownloadContent}>
          <div className={styles.agentDownloadText}>
            <h4 className={styles.agentDownloadTitle}>Agent Not Installed</h4>
            <p className={styles.agentDownloadDescription}>
              To manage endpoints, install the agent on each device first.
              Without it, policies cannot be applied.
            </p>
          </div>
          <div className={styles.agentDownloadActions}>
            <Link
              to="/app/enrollment/devices"
              className={styles.agentDownloadPrimaryAction}
            >
              <img
                src={downloadIcon}
                alt=""
                className={styles.agentDownloadActionIcon}
              />
              <span>Download Agent</span>
            </Link>
            <a
              href="https://zecurit.com/help/asset-management/device-enrollment/overview-of-device-enrollment/"
              className={styles.agentDownloadSecondaryAction}
              target="_blank"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>
    }
  />
);

export default AgentDownloadAlert;
